import styled from "@emotion/styled";
import React from "react";
import { Marker } from "react-map-gl/maplibre";
import { DefinedPlaceResult } from "./MainNavbar";

export default function SearchedPlaceMapMarker(props: { place: DefinedPlaceResult }) {
  return (
    <Marker
      latitude={props.place.geometry.location.lat()}
      longitude={props.place.geometry.location.lng()}
    >
      <Root>{props.place.formatted_address}</Root>
    </Marker>
  );
}

const Root = styled.div`
  --bg-color: var(--tw-emerald-600);
  --arrow-size: 4px;
  background-color: var(--bg-color);
  border-radius: 24px;
  color: white;
  padding: 8px 12px;
  font-family: var(--font-family);
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:after {
    --real-arrow-size: calc(var(--arrow-size) + 1px);
    content: "";
    position: absolute;
    bottom: calc(var(--arrow-size) * -1 + 1px);
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: var(--real-arrow-size) solid transparent;
    border-right: var(--real-arrow-size) solid transparent;
    border-top: var(--real-arrow-size) solid var(--bg-color);
    transition: all 250ms ease;
  }
`;
